import { DOMUtils } from '../../../../utils/dom'
import { Mixin } from '../../../../utils/mixin'
import { AdBiddingProvider, IAdBiddingAdapter, IAdBiddingProviderConfig } from '../adapter'

export interface IWindow extends Window {
    deployads: any
}

declare let window: IWindow

/**
 * NOTE: noticed a limitation with the trait/mixin strategy used here in that the first in a chain
 * needs to act on the top-most class, whereas successive need to act on their self class in order
 * to call supers.
 */
export const WithSortableBidding  = <T extends Mixin<IAdBiddingAdapter>>(Base: T) =>
class extends Base implements IAdBiddingAdapter {
        public sortableEnabled = false
        private sortableJsPath = '//tags-cdn.deployads.com/a/'

        /**
         * Loads JS library for given account.
         */
        public initializeBidding(confs: IAdBiddingProviderConfig[], ...args: any[]) {
            super.initializeBidding(confs, ...args)

            // multiple providers are supported, so fetch conf by name
            const conf = confs.find((_) => _.client === AdBiddingProvider.SORTABLE)
            if (conf) {

                // load JS
                DOMUtils.loadScript(`${this.sortableJsPath}${conf.account}.com.js`)

                // setup global object
                if (!window.deployads) {
                    window.deployads = window.deployads || []
                }
                this.sortableEnabled = true

            }
        }
    }
